// @flow
import * as React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';

const HASHTAG_FLAG = '__HashtagFlag__';
const MAXIMUM_HASHTAGS = 4;
export const HASHTAG_REGEX = /#[^(\-\\.\s#,\/$%\^&\*;:{}=\`~()\[\]@|<>…)]+/gi;
const getHashtagLink = (hashtag, source) =>
  `/search/pins/?q=${encodeURIComponent(hashtag)}&rs=${source}`;
export const TRANSFORMER_OPTIONS_KEY = 'hashtags';
export type TransformPartsOptions = {
  appendText?: string,
  source?: string,
};

export function transformParts(parts: Array<React.Node>, options: TransformPartsOptions) {
  const appendText = options.appendText || '';
  const source = options.source || 'hashtag_pinrep';

  let newParts = [];

  const hashtags = [];
  const isHashtagAdded = {};
  let hashtagCount = 0;

  const mapTokensToLinks = (partIndex) => (token, index) => {
    if (token === HASHTAG_FLAG && hashtags.length) {
      const hashtag = hashtags.shift();
      hashtagCount += 1;
      return (
        <NavigateLink to={getHashtagLink(hashtag, source)} key={`hashtag-${partIndex}.${index}`}>
          <span className="pinHashtag">{hashtag}</span>
        </NavigateLink>
      );
    } else {
      return token;
    }
  };

  // Iterate over all parts and look for strings. If it's a string, split
  // the string on all hashtags and replace them with linked variants.
  for (let partIndex = 0; partIndex < parts.length; partIndex += 1) {
    const part = parts[partIndex];

    if (typeof part === 'string') {
      const tokens = part
        .replace(HASHTAG_REGEX, (hashtag: string) => {
          hashtags.push(hashtag);
          isHashtagAdded[hashtag] = true;
          return HASHTAG_FLAG;
        })
        .split(new RegExp(`(${HASHTAG_FLAG})`));

      const contents = tokens.map(mapTokensToLinks(partIndex));

      newParts = [...newParts, ...contents];
    } else {
      newParts.push(part);
    }
  }

  // Detect hashtags in appended text and append them to the parts list.
  const appendedHashtags = [];
  if (appendText) {
    appendText.replace(HASHTAG_REGEX, (hashtag: string, index: number) => {
      if (!isHashtagAdded[hashtag] && hashtagCount < MAXIMUM_HASHTAGS) {
        hashtagCount += 1;
        appendedHashtags.push(
          <span key={'appended' + index}>
            &nbsp;
            <NavigateLink to={getHashtagLink(hashtag, source)}>
              <span className="pinHashtag">{hashtag}</span>
            </NavigateLink>
          </span>,
        );
        isHashtagAdded[hashtag] = true;
      }
      return hashtag;
    });
  }

  newParts = [...newParts, ...appendedHashtags];

  return newParts;
}
